import React, { forwardRef } from "react";

const InputTextarea = forwardRef((props, ref) => {
	return (
		<div className="form-group boxed pt-0">
			<div className="input-wrapper">
				{props.label && (
					<label className="label" htmlFor="Note">
						{props.label}
					</label>
				)}
				<textarea
					className="form-control"
					rows={props.rowsLength}
					value={props.value}
					onChange={(e) => props.setValue(e.target.value)}
					required={props.required}
					ref={ref}
					disabled={props.disabled}
				/>
				<i className={`clear-input ${props.value !== "" ? "d-flex" : ""}`} onClick={() => props.setValue("")}>
					<ion-icon aria-label="close circle" className="md hydrated" name="close-circle" role="img" />
				</i>
			</div>
		</div>
	);
});

InputTextarea.defaultProps = {
	rowsLength: 2,
	value: "",
	required: false,
	disabled: false,
};

export default InputTextarea;
